<template>
  <div
    class="container"
    id="Pricing"
    style="backgroundImage: url(./img/whitebackground.png); background-size: cover; min-height: calc(100vh - 66px);"
  >
    <div class="md-layout" style="padding-bottom: 80px;">
      <div
        class="md-layout-item md-size-100 md-small-size-100"
        style="height: 100px"
      >
        <br />
        &nbsp;&nbsp;
        <br />
      </div>
      <div
        class="md-layout-item md-size-100 md-small-hide"
        style="max-height: 580px"
      ></div>
      <div class="md-layout-item md-size-5 md-small-hide"></div>
      <div
        class="md-layout-item md-size-30 md-small-size-100"
        style="min-height: 681px;"
      >
        <pricing-card>
          <template slot="cardContent">
            <h6 class="card-category text-gray">{{ $t("ENTERPRISE") }}</h6>
            <h1 class="card-title">
              {{ $t("Contact us") }}
            </h1>
            <ul>
              <li>{{ $t("Automated Site Surveys") }}</li>
              <li>
                {{ $t("Complete Access to CFS, VTA, VNC, CWAS") }}
                <br />({{ $t("aeronautical charts costing over $1000/yr!") }})
              </li>
              <li>
                {{ $t("Customizable Checklist + Checklist Timestamps") }}
                <br />{{ $t("Integrated Flight Log") }}
              </li>
              <li>
                {{ $t("Multiple Pilot Management + Training Log") }}<br />{{
                  $t("Multiple Device Management + Maintenance Log")
                }}<br />{{ $t("Client Management") }}
              </li>
              <li>
                {{ $t("Admin Dashboard to Monitor Team Activity") }}<br />{{
                  $t("Create Site Surveys for Team")
                }}<br />{{
                  $t(
                    "Smart Alerts for Incident Notification and Early Warnings"
                  )
                }}
              </li>
            </ul>
          </template>
        </pricing-card>

        <br />
      </div>
      <div
        class="md-layout-item md-size-30 md-small-size-100"
        style="min-height: 681px;"
      >
        <pricing-card>
          <template slot="cardContent">
            <div class="ribbon ribbon-top-right">
              <span>{{ $t("GREAT VALUE") }}</span>
            </div>
            <h6 class="card-category text-gray">{{ $t("PRO") }}</h6>
            <h1 class="card-title">
              <small>{{ $t("from") + " $" }}</small>
              3.00
              <small>{{ $t("per month") }}</small>
            </h1>
            <ul>
              <li>{{ $t("Automated Site Surveys") }}</li>
              <li>{{ $t("Schedule Flights in Advance on WEB & Mobile") }}</li>
              <li>
                {{ $t("Complete Access to CFS, VTA, VNC, CWAS") }}
                <br />({{ $t("aeronautical charts costing over $1000/yr!") }})
              </li>
              <li>
                {{ $t("Customizable Checklist + Checklist Timestamps") }}
                <br />{{ $t("Integrated Flight Log") }}
              </li>
              <li>
                {{ $t("Single Pilot User") }}<br />{{
                  $t("Multiple Device Management")
                }}
              </li>
              <li>
                <md-button class="md-raised md-primary" @click="signup">{{
                  $t("Sign Up")
                }}</md-button>
              </li>
            </ul>
          </template>
        </pricing-card>
        <br />
      </div>
      <div
        class="md-layout-item md-size-30 md-small-size-100"
        style="min-height: 681px;"
      >
        <pricing-card>
          <template
            slot="cardContent"
            style="overflow: hidden; position:relative;"
          >
            <h6 class="card-category text-gray">{{ $t("STARTER") }}</h6>
            <h1 class="card-title">
              {{ $t("free") }}
            </h1>
            <ul>
              <li>{{ $t("Automated Site Surveys") }}</li>
              <li>{{ $t("Fly Now - Mobile Only") }}</li>
              <li>
                {{ $t("CFS Access for Mission-Relevant Aerodromes") }}
              </li>
              <li>
                {{ $t("Standard Checklist") }}
                <br />{{ $t("Integrated Flight Log") }}
              </li>
              <li>
                {{ $t("Single Pilot User") }}<br />{{
                  $t("Single Device Management")
                }}
              </li>
              <li>&nbsp;<br />&nbsp;<br />&nbsp;</li>
            </ul>
          </template>
        </pricing-card>
      </div>
      <div class="md-layout-item md-size-5 md-small-hide"></div>

      <div class="md-layout-item md-size-30 md-small-size-100"></div>
      <div class="md-layout-item md-size-100 md-small-hide"></div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <br />
      </div>
    </div>
    <modal v-if="showSignup">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeSignup"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <register></register>
      </template>
    </modal>
  </div>
</template>

<script>
import { PricingCard } from "@/components";
import "@/assets/css/ribbon.css";
import Register from "@/pages/Landing/Register.vue";
import { Modal } from "@/components";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  name: "pricing",
  data() {
    return {
      selectedFrequency: "y",
      selectedQuantity: 0,
      enterpriseCost: 0,
      proCost: 0,
      showSignup: false
    };
  },
  components: {
    PricingCard,
    Modal,
    Register
  },
  mounted() {
    this.selectedFrequency = "y";
    this.selectedQuantity = 1;
    this.updatePrice();
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  methods: {
    signup() {
      this.$router.push("/signup");
    },
    closeSignup() {
      this.showSignup = false;
    },
    updatePrice() {
      this.enterpriseCost = 0;
      if (this.selectedFrequency === "y") {
        if (this.selectedQuantity > 20) {
          this.enterpriseCost =
            200 * 10 + 150 * 10 + 100 * (this.selectedQuantity - 20);
        } else if (this.selectedQuantity > 10) {
          this.enterpriseCost = 200 * 10 + 150 * (this.selectedQuantity - 10);
        } else {
          this.enterpriseCost = 200 * this.selectedQuantity;
        }
      } else {
        if (this.selectedQuantity > 20) {
          this.enterpriseCost =
            28 * 10 + 21 * 10 + 14 * (this.selectedQuantity - 20);
        } else if (this.selectedQuantity > 10) {
          this.enterpriseCost = 28 * 10 + 21 * (this.selectedQuantity - 10);
        } else {
          this.enterpriseCost = 28 * this.selectedQuantity;
        }
      }
    },
    decreaseQuantity() {
      if (this.selectedQuantity > 1) {
        this.selectedQuantity--;
      }
      this.updatePrice();
    },
    increaseQuantity() {
      if (this.selectedQuantity < 99) {
        this.selectedQuantity++;
      }
      this.updatePrice();
    },
    updateFrequency() {
      this.updatePrice();
    }
  },
  beforeDestroy() {
    EventBus.$off("signedup");
  }
};
</script>

<style lang="css">
.quantity {
  font-size: 20px;
  font-weight: 400;
  margin: 0px 20px 0px 20px;
  line-height: 51px;
  color: #666;
}
</style>
